import Axios from "@/plugins/Axios";

export class UsabilidadeService {
  async getProfessoresUsabilidade(configuracao_id) {
    const response = await Axios().get(`usabilidade/professores-usabilidade/${configuracao_id}`);
    return response.data.franquiaComGestoes;
  }

  async getCoordenadorUsabilidade(configuracao_id) {
    const response = await Axios().get(`usabilidade/coordenador-usabilidade/${configuracao_id}`);
    return response.data.franquiaComGestoes;
  }
}
export default new UsabilidadeService();
